import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {RootState} from '@/store';
import type {CreditUsage} from '@Components/feedback-toast/toast-content/toast-content.types';

export interface AiRedesignFeedbackToast {
  redesignHashedId: string;
  creditUsage?: CreditUsage;
}

interface StateProps {
  isLoading: boolean;
  lastRunCreditsCharged?: number;
  isOpenRequested: boolean;
  feedbackToast: AiRedesignFeedbackToast | null;
}

const initialState: StateProps = {
  isLoading: false,
  isOpenRequested: false,
  feedbackToast: null,
};

export const emailMakerAiRedesignPromptBoxSlice = createSlice({
  name: 'emailMakerAiRedesignPromptBox',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setLastRunCreditsCharged: (state, action: PayloadAction<number | undefined>) => {
      state.lastRunCreditsCharged = action.payload;
    },
    requestAiRedesignModalOpen: (state) => {
      state.isOpenRequested = true;
    },
    consumeAiRedesignModalOpenRequest: (state) => {
      state.isOpenRequested = false;
    },
    showAiRedesignFeedbackToast: (state, action: PayloadAction<AiRedesignFeedbackToast>) => {
      state.feedbackToast = action.payload;
    },
  },
});

export const {setIsLoading, setLastRunCreditsCharged, requestAiRedesignModalOpen, consumeAiRedesignModalOpenRequest, showAiRedesignFeedbackToast} =
  emailMakerAiRedesignPromptBoxSlice.actions;

export const emailMakerAiRedesignPromptBoxReducer = emailMakerAiRedesignPromptBoxSlice.reducer;

export const selectIsAiRedesignInProgress = (state: RootState): boolean => {
  return state.emailMakerAiRedesignPromptBox.isLoading;
};
